import { render, staticRenderFns } from "./HomeTitle.vue?vue&type=template&id=0065d834&scoped=true&functional=true&"
import script from "./HomeTitle.vue?vue&type=script&lang=ts&"
export * from "./HomeTitle.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTitle.vue?vue&type=style&index=0&id=0065d834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0065d834",
  null
  
)

export default component.exports